import { decode, JwtPayload } from 'jsonwebtoken';

import { fetchUserAccountNumber } from './fetch-user-account';

import { PATIENT_SERVICES_BASE_URL } from '@src/constants';

export const unprotectedPatientServicesRoutes = [
	`/${PATIENT_SERVICES_BASE_URL}`,
	`/${PATIENT_SERVICES_BASE_URL}/`,
	`/${PATIENT_SERVICES_BASE_URL}/cancel/success/`,
	`/${PATIENT_SERVICES_BASE_URL}/cancel/success`,
	`/${PATIENT_SERVICES_BASE_URL}/reschedule/success/`,
	`/${PATIENT_SERVICES_BASE_URL}/reschedule/success`,
	`/${PATIENT_SERVICES_BASE_URL}/global-error/`,
	`/${PATIENT_SERVICES_BASE_URL}/global-error`,
	`/${PATIENT_SERVICES_BASE_URL}/expiration/`,
	`/${PATIENT_SERVICES_BASE_URL}/expiration`,
	`/${PATIENT_SERVICES_BASE_URL}/authentication/`,
	`/${PATIENT_SERVICES_BASE_URL}/authentication`,
	`/${PATIENT_SERVICES_BASE_URL}/appointment/confirmation/`,
	`/${PATIENT_SERVICES_BASE_URL}/appointment/confirmation`,
];

const patientServicesOneClickRoutes = new Set([
	`/${PATIENT_SERVICES_BASE_URL}/cancel/`,
	`/${PATIENT_SERVICES_BASE_URL}/reschedule/`,
	`/${PATIENT_SERVICES_BASE_URL}/confirm/`,
]);

export const patientServicesAuthRoutes = [
	`/${PATIENT_SERVICES_BASE_URL}/`,
	`/${PATIENT_SERVICES_BASE_URL}`,
	`/${PATIENT_SERVICES_BASE_URL}/authentication/`,
	`/${PATIENT_SERVICES_BASE_URL}/authentication`,
];

export const accountNumberQuery = `query getAccountNumber {
    me {
      account {
        accountNumber
      }
    }
}`;

export const authenticationErrorMessage = 'The current user is not authorized to access this resource.';

export const isTokenExpired = (token: string | null): boolean => {
	if (!token) return true;
	const decoded = decode(token) as JwtPayload;
	return !decoded?.exp || Date.now() >= decoded.exp * 1000;
};

export const shouldRedirectToLogin = async (session: string | undefined): Promise<boolean> => {
	try {
		const response = await fetchUserAccountNumber(session);
		return response?.errors?.some(({ message }) => message === authenticationErrorMessage);
	} catch {
		return true;
	}
};

export const isRouteProtected = (pathname: string): boolean => {
	return !unprotectedPatientServicesRoutes.includes(pathname);
};

export const isOneClickLogin = (pathname: string, search: string): boolean => {
	return patientServicesOneClickRoutes.has(pathname) && search.includes('token') && search.includes('appointmentId');
};
